import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send, Instagram, Facebook, Clock } from 'lucide-react';
import Header from './components/Header11';
import Footer from './components/Footer11';

const Contact11 = () => {
    const [formData, setFormData] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
    const [submitted, setSubmitted] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitted(true);
    };

    const inputStyle = {
        width: '100%', padding: '14px 16px', backgroundColor: '#292524', border: '1px solid #44403C', color: '#FAFAF9',
        fontFamily: "'Source Sans 3', sans-serif", fontSize: '14px', outline: 'none', transition: 'border-color 0.3s ease',
    };

    const contactInfo = [
        { icon: Phone, label: 'Phone', value: '+91 98765 43210', subtext: 'Mon-Sat, 10am - 7pm' },
        { icon: Mail, label: 'Email', value: 'support@veer.in', subtext: 'We reply within 24 hours' },
        { icon: MapPin, label: 'Studio', value: 'MG Road, Bangalore 560001', subtext: 'Visit by appointment' },
        { icon: Clock, label: 'Hours', value: 'Mon - Sat: 10am - 7pm', subtext: 'Closed on Sundays' },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&family=Source+Sans+3:wght@300;400;600&display=swap');
                .veer-contact-input:focus { border-color: #D97706 !important; }
                .veer-contact-input::placeholder { color: #78716C; }
            `}</style>

            <div style={{ fontFamily: "'Source Sans 3', -apple-system, sans-serif" }} className="min-h-screen bg-[#1C1917]">
                <Header />

                <main className="pt-[100px] pb-16 px-4 sm:px-6">
                    <div className="max-w-[1200px] mx-auto">
                        {/* Header */}
                        <div className="text-center mb-12">
                            <div className="w-10 h-0.5 mx-auto mb-4" style={{ backgroundColor: '#D97706' }} />
                            <p className="text-xs tracking-[0.3em] uppercase mb-3" style={{ color: '#D97706', fontFamily: "'Oswald', sans-serif", fontWeight: 500 }}>Get in Touch</p>
                            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase', letterSpacing: '2px' }}>CONTACT US</h1>
                            <p className="text-sm max-w-md mx-auto" style={{ color: '#A8A29E' }}>Questions about sizing, orders, or custom tailoring? We are here to help.</p>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
                            {/* Contact Info */}
                            <div className="lg:col-span-2 space-y-6">
                                {contactInfo.map(({ icon: Icon, label, value, subtext }, i) => (
                                    <div key={i} className="flex gap-4 p-5" style={{ backgroundColor: '#292524', border: '1px solid #44403C' }}>
                                        <div className="w-10 h-10 flex items-center justify-center flex-shrink-0" style={{ border: '1px solid #D97706' }}>
                                            <Icon size={18} style={{ color: '#D97706' }} />
                                        </div>
                                        <div>
                                            <p className="text-xs uppercase tracking-wider mb-1" style={{ fontFamily: "'Oswald', sans-serif", fontWeight: 500, color: '#D97706' }}>{label}</p>
                                            <p className="text-sm font-semibold" style={{ color: '#FAFAF9' }}>{value}</p>
                                            <p className="text-xs mt-1" style={{ color: '#A8A29E' }}>{subtext}</p>
                                        </div>
                                    </div>
                                ))}
                                <div className="flex gap-3 pt-4">
                                    {[Instagram, Facebook].map((Icon, i) => (
                                        <a key={i} href="#" className="w-10 h-10 flex items-center justify-center transition-all duration-300" style={{ border: '1px solid #44403C', color: '#A8A29E', textDecoration: 'none' }}
                                            onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#D97706'; e.currentTarget.style.color = '#D97706'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#44403C'; e.currentTarget.style.color = '#A8A29E'; }}
                                        >
                                            <Icon size={18} />
                                        </a>
                                    ))}
                                </div>
                            </div>

                            {/* Form */}
                            <div className="lg:col-span-3 p-6 sm:p-8" style={{ backgroundColor: '#292524', border: '1px solid #44403C' }}>
                                {submitted ? (
                                    <div className="text-center py-12">
                                        <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center" style={{ backgroundColor: 'rgba(217,119,6,0.1)', border: '1px solid #D97706' }}>
                                            <Send size={24} style={{ color: '#D97706' }} />
                                        </div>
                                        <h2 className="text-xl font-semibold mb-2" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase' }}>Message Sent</h2>
                                        <p className="text-sm" style={{ color: '#A8A29E' }}>We will get back to you within 24 hours.</p>
                                    </div>
                                ) : (
                                    <>
                                        <h2 className="text-lg font-semibold mb-6" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase', letterSpacing: '2px' }}>SEND A MESSAGE</h2>
                                        <form onSubmit={handleSubmit} className="space-y-4">
                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                <input name="name" value={formData.name} onChange={handleInputChange} placeholder="Your Name" style={inputStyle} className="veer-contact-input" />
                                                <input name="email" type="email" value={formData.email} onChange={handleInputChange} placeholder="Email" style={inputStyle} className="veer-contact-input" />
                                            </div>
                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                <input name="phone" value={formData.phone} onChange={handleInputChange} placeholder="Phone" style={inputStyle} className="veer-contact-input" />
                                                <input name="subject" value={formData.subject} onChange={handleInputChange} placeholder="Subject" style={inputStyle} className="veer-contact-input" />
                                            </div>
                                            <textarea name="message" value={formData.message} onChange={handleInputChange} placeholder="Your message..." rows={5} style={{ ...inputStyle, resize: 'vertical' }} className="veer-contact-input" />
                                            <button type="submit" className="w-full flex items-center justify-center gap-2 py-4 text-sm tracking-[0.15em] uppercase transition-colors duration-300" style={{ backgroundColor: '#D97706', border: 'none', color: '#1C1917', fontFamily: "'Oswald', sans-serif", fontWeight: 600, cursor: 'pointer' }}
                                                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F59E0B')}
                                                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#D97706')}
                                            >
                                                <Send size={16} /> Send Message
                                            </button>
                                        </form>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default Contact11;
